import { Status } from "./Status";


export class CaseMaterialStatusSmartEnum {
    static Packed = new Status("Packed", 1, "pill--green");
    static Disposed = new Status("Disposed", 2, "pill--red");
    static Disposing = new Status("Disposing", 3, "pill--orange");
    static Merged = new Status("Merged", 4, "pill--blue");
    static Recalling = new Status("Recalling", 5, "pill--blue");
    static Recalled = new Status("Recalled", 6, "pill--blue");
    static Invalid = new Status("Not Found", 7, "pill--red", "Invalid"); // Even though the state is technically invalid, cellnass want it displaying as not found
    static Packing = new Status("Packing", 8, "pill--green");
    static Created = new Status("Created", 9, "pill--grey");
    static Picked = new Status("Picked", 10, "pill--orange");
    static Mixed = new Status("Mixed", 11, "pill--yellow");
    static Unknown = new Status("Unknown", 12, "pill--grey");
    static Returning = new Status("Returning", 13, "pill--orange");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "CaseMaterialStatusSmartEnum";
    }
}
